import { useState } from 'react';

import { Button } from '@components/button';
import { Checkbox } from '@components/checkbox';
import { IconTrash } from '@components/icons/trash';
import { hideModal, Modal, useModal } from '@components/modal';
import { Separator } from '@components/separator';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';

import { useDeleteUser } from 'api/users/hooks';
import { User } from 'api/users/requests';

export const useDeleteTeamUserModal = () => useModal(DeleteTeamUser);

export const DeleteTeamUser = ({ user }: { user: User }) => {
  const { t } = useScopedTranslate(locale);
  const [isConfirm, setIsConfirm] = useState(false);

  const onSuccess = () => {
    hideModal();
  };
  const deleteMutation = useDeleteUser({
    id: user.id,
    onSuccess,
  });

  return (
    <Modal>
      <Modal.SimpleHeader title={t('deleteTraveller')} />
      <Modal.Content>
        <Stack space={6}>
          <Stack>
            <Text text={t('areYouSure', { name: user?.name })} />
            <Text color="elementRed100" text={t('cannotBeUndone')} />
          </Stack>
          <Separator />
          <Stack space={4}>
            <Text font="semibold14" text={t('pleaseConfirm')} />
            <Checkbox label={t('iUnderstand')} onChange={setIsConfirm} />
          </Stack>
        </Stack>
        <Stack orientation="horizontal" space={4} justify="flex-end">
          <Button variant="secondary" onClick={hideModal} text={t('core.cancel')} />
          <Button
            isDisabled={!isConfirm}
            onClick={() => deleteMutation.mutate()}
            disabled={deleteMutation.isLoading}
            variant="primary-red"
            iconLeft={<IconTrash />}
            text={t('core.delete')}
          />
        </Stack>
      </Modal.Content>
    </Modal>
  );
};

export const locale = {
  en: {
    deleteTraveller: 'Delete user',
    areYouSure: 'Are you sure you want to delete user {name}?',
    cannotBeUndone: 'This can not be undone.',
    pleaseConfirm: 'Please confirm',
    iUnderstand: 'I understand',
  },
};
